import React from 'react';
import {Divider, Typography} from '@mui/material';
import {StyledCard} from 'presentation/components';
import {MessageProps} from './types';

export function Message({dtMensagem, dsMensagem}: MessageProps) {
	return (
		<StyledCard.Container sx={{gap: 1, p: 0}}>
			<Typography variant="body2" color="text.primary" textTransform={'uppercase'}>
				{dsMensagem}
			</Typography>
			<Divider />
			<Typography variant="body2" color="primary">
				{dtMensagem}
			</Typography>
		</StyledCard.Container>
	);
}
